(function () {
  function init(root) {
    var section = root.querySelector('[data-dv-pdp]') || (root.matches && root.matches('[data-dv-pdp]') ? root : null);
    if (!section || section.dataset.dvReady) return;
    section.dataset.dvReady = '1';

    var data = {};
    try { data = JSON.parse(section.querySelector('[data-dv-product-json]').textContent); } catch (e) { data = { variants: [] }; }
    var track = section.querySelector('[data-dv-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.dv-pdp__slide')) : [];
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-dv-thumb]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('.dv-pdp__dots i'));
    var form = section.querySelector('#DorvenProductForm');
    var input = section.querySelector('[data-dv-variant-input]');

    /* Gallery */
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function goTo(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-dv-thumb'), 10)); });
    });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          setActive(i);
        });
      });
    }
    /* Start on the selected variant's image */
    var startThumb = section.querySelector('.dv-pdp__thumb.is-active');
    if (startThumb) goTo(parseInt(startThumb.getAttribute('data-dv-thumb'), 10), false);

    /* Hover zoom (desktop) */
    if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        s.addEventListener('mousemove', function (e) {
          var r = s.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          s.classList.add('is-zoom');
        });
        s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
      });
    }

    /* Variants */
    var mainVariant = (data.variants || []).filter(function (x) { return String(x.id) === String(input && input.value); })[0] || (data.variants || [])[0];
    var priceEl = section.querySelector('[data-dv-price]');
    var badge = section.querySelector('[data-dv-badge]');
    function selectVariant(id) {
      var v = (data.variants || []).filter(function (x) { return x.id === id; })[0];
      if (!v) return;
      input.value = v.id;
      mainVariant = v;
      if (typeof updateBogo === 'function') updateBogo();
      section.querySelectorAll('[data-dv-variant]').forEach(function (b) {
        var on = parseInt(b.getAttribute('data-dv-variant'), 10) === v.id;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var name = section.querySelector('[data-dv-finish-name]'); if (name) name.textContent = v.title;
      var sku = section.querySelector('[data-dv-sku]'); if (sku && v.sku) sku.textContent = v.sku;
      if (priceEl) {
        priceEl.innerHTML = v.compare
          ? '<span class="is-now">' + v.price + '</span><s>' + v.compare + '</s><span class="dv-pdp__save">You save ' + v.save + '</span>'
          : '<span class="is-regular">' + v.price + '</span>';
      }
      if (badge) { badge.textContent = '−' + v.pct + '%'; badge.style.display = v.pct ? '' : 'none'; }
      var add = section.querySelector('[data-dv-add]');
      var label = section.querySelector('[data-dv-add-label]');
      if (add) add.disabled = !v.available;
      if (label) label.textContent = v.available ? 'Add to bag' : 'Sold out';
      var bf = section.querySelector('[data-dv-bar-finish]'); if (bf) bf.textContent = v.title;
      var bp = section.querySelector('[data-dv-bar-price]'); if (bp) bp.textContent = v.price;
      var bi = section.querySelector('[data-dv-bar-img]'); if (bi && v.thumb) bi.src = v.thumb;
      if (v.media) {
        slides.forEach(function (s, i) { if (parseInt(s.getAttribute('data-media-id'), 10) === v.media) goTo(i); });
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    section.querySelectorAll('[data-dv-variant]').forEach(function (b) {
      b.addEventListener('click', function () { selectVariant(parseInt(b.getAttribute('data-dv-variant'), 10)); });
    });


    /* Buy 1, get 1 free: second watch selector */
    var bogo = section.querySelector('[data-dv-bogo]');
    var bogoOn = bogo ? bogo.querySelector('[data-dv-bogo-on]') : null;
    var products = (data.products || []).filter(Boolean);
    var second = null;
    function findProduct(pid) { return products.filter(function (p) { return String(p.id) === String(pid); })[0]; }
    function renderFinishes(prod, keepId) {
      var wrap = bogo.querySelector('[data-dv-bogo-finishes]');
      wrap.innerHTML = '';
      var chosen = null;
      prod.variants.forEach(function (v) {
        if (!v.available) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'dv-bogo__finish'; b.setAttribute('aria-label', v.title); b.title = v.title;
        b.innerHTML = '<img src="' + v.thumb + '" alt="" width="40" height="40" style="opacity:1;visibility:visible">';
        b.addEventListener('click', function () { setSecond(prod, v); });
        b.dataset.vid = v.id;
        wrap.appendChild(b);
        if (!chosen || String(v.id) === String(keepId)) chosen = v;
      });
      if (chosen) setSecond(prod, chosen);
    }
    function setSecond(prod, v) {
      second = { product: prod, variant: v };
      bogo.querySelectorAll('[data-dv-bogo-model]').forEach(function (b) {
        var on = String(b.getAttribute('data-dv-bogo-model')) === String(prod.id);
        b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      bogo.querySelectorAll('.dv-bogo__finish').forEach(function (b) { b.classList.toggle('is-active', String(b.dataset.vid) === String(v.id)); });
      updateBogo();
    }
    function updateBogo() {
      if (!bogo || !second || !mainVariant) return;
      var mainName = (section.querySelector('.dv-pdp__title') || {}).textContent || '';
      var a = { name: mainName.trim() + ' · ' + mainVariant.title, cents: mainVariant.cents, price: mainVariant.price };
      var b = { name: second.product.title + ' · ' + second.variant.title, cents: second.variant.cents, price: second.variant.price };
      var pay = a.cents >= b.cents ? a : b, free = pay === a ? b : a;
      bogo.querySelector('[data-dv-bogo-name]').textContent = second.product.title;
      var bc = bogo.querySelector('[data-dv-bogo-color]'); if (bc) bc.textContent = second.variant.title;
      bogo.querySelector('[data-dv-bogo-pay]').textContent = pay.name + ' — ' + pay.price;
      bogo.querySelector('[data-dv-bogo-free]').textContent = free.name + ' — ' + free.price;
    }
    if (bogo && products.length) {
      bogo.querySelectorAll('[data-dv-bogo-model]').forEach(function (b) {
        b.addEventListener('click', function () { var pr = findProduct(b.getAttribute('data-dv-bogo-model')); if (pr) renderFinishes(pr); });
      });
      var startProd = findProduct(section.getAttribute('data-product-id')) || products[0];
      renderFinishes(startProd, mainVariant && mainVariant.id);
      bogoOn.addEventListener('change', function () { bogo.classList.toggle('is-off', !bogoOn.checked); });
    }

    /* Quantity */
    var qty = section.querySelector('[data-dv-qty-input]');
    section.querySelectorAll('[data-dv-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, Math.min(10, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-dv-qty'), 10)));
        qty.value = n;
      });
    });

    /* Add to bag: AJAX, then open the cart (falls back to normal submit) */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var btn = section.querySelector('[data-dv-add]');
        btn.classList.add('is-loading');
        var opts = { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) };
        if (bogo && bogoOn && bogoOn.checked && second) {
          opts = { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [
              { id: parseInt(input.value, 10), quantity: Math.max(1, parseInt((qty && qty.value) || 1, 10)) },
              { id: second.variant.id, quantity: 1 }
            ] }) };
        }
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', opts).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) { btn.classList.remove('is-loading'); alertMsg(res.j.description || 'Could not add to bag.'); return; }
            document.dispatchEvent(new CustomEvent('dorven:cart:added', { detail: res.j }));
            if (window.DorvenCart) {
              btn.classList.remove('is-loading');
              window.DorvenCart.open();
            } else {
              window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
            }
          })
          .catch(function () { form.submit(); });
      });
    }
    function alertMsg(text) {
      var p = section.querySelector('.dv-pdp__error');
      if (!p) { p = document.createElement('p'); p.className = 'dv-pdp__error'; p.setAttribute('role', 'alert'); p.style.cssText = 'margin:10px 0 0;color:#8A1F2D;font-size:15px;'; form.appendChild(p); }
      p.textContent = text;
    }

    /* Sticky bar */
    var bar = section.querySelector('[data-dv-bar]');
    var addBtn = section.querySelector('[data-dv-add]');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var below = entries[0].boundingClientRect.top < 0;
        var show = !entries[0].isIntersecting && below;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelector('[data-dv-bar-add]').tabIndex = show ? 0 : -1;
      }, { threshold: 0 }).observe(addBtn);
      bar.querySelector('[data-dv-bar-add]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }

    /* Delivery estimate: dispatch 1–3 + transit 7–12 business days */
    var eta = section.querySelector('[data-dv-eta]');
    if (eta) {
      function addBusinessDays(d, n) {
        var x = new Date(d.getTime());
        while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
        return x;
      }
      var now = new Date();
      var from = addBusinessDays(now, 8), to = addBusinessDays(now, 15);
      var fmt = { month: 'short', day: 'numeric' };
      try { eta.textContent = 'between ' + from.toLocaleDateString('en-US', fmt) + ' and ' + to.toLocaleDateString('en-US', fmt); } catch (e) {}
    }
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
